import { HasConditions } from './has-conditions.model';
import { SurveyBase } from './survey-base.model';

export interface SurveyElementModel extends SurveyBase, HasConditions {}

export class SurveyElementModel {
  id: string;
}

applyMixins(SurveyElementModel, [SurveyBase, HasConditions]);

function applyMixins(derivedCtor: new (...args: never[]) => unknown, constructors: Array<new (...args: never[]) => unknown>): void {
  constructors.forEach((baseCtor) => {
    Object.getOwnPropertyNames(baseCtor.prototype).forEach((name) => {
      Object.defineProperty(derivedCtor.prototype, name, Object.getOwnPropertyDescriptor(baseCtor.prototype, name));
    });
  });
}
